import React from 'react';
/** import third-party libraries in the section above, Sort Lines Ascending */

import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
/** import mui components in the section above, Sort Lines Ascending */

import { sortRecordsByName } from 'states/resources/organizations/business-logic';
import NotFoundRecipientLabel from '../not-found-recipient-label';
/** import classes and others in the section above, Sort Lines Ascending */

/**
 * Collapsed accordion summary for schedule report recipients.
 * Resolves selected emails to user objects or not-found stubs, sorts, and renders name — email lines.
 *
 * @param {Object} props
 * @param {Array<{id: *, name: string, email: string}>} [props.users] - Active org users from API
 * @param {string[]} props.selectedEmails - Selected emails; unresolved entries shown as not-found
 * @returns {React.ReactElement}
 */
function RecipientsSelectorSummary(props) {
    const { users, selectedEmails } = props;
    const usersByEmail = Object.fromEntries((users || []).map(user => [user.email, user]));
    const selectedRecipients = (selectedEmails || []).map(
        // Email may exist in schedule.recipients but not in current org users (e.g. removed user)
        // Sorting by name will place unavailable users first, which will be rendered with NotFoundRecipientLabel
        email => usersByEmail[email] || { id: null, name: null, email }
    );
    const sortedSelected = sortRecordsByName(selectedRecipients, { nameField: 'name' });

    return (
        <Box>
            {sortedSelected.map(recipient => (
                <Typography key={recipient.id ?? recipient.email}>
                    {recipient.id === null ? (
                        <>
                            <NotFoundRecipientLabel /> — {recipient.email}
                        </>
                    ) : (
                        <>
                            {recipient.name} — {recipient.email}
                        </>
                    )}
                </Typography>
            ))}
        </Box>
    );
}

export default RecipientsSelectorSummary;
